import * as ons from 'onsenui';

/**
 * @object onsNotification
 */
export const onsNotification = ons.notification;
